import _ from 'lodash';
import React from 'react';

const filterFunds = (
  funds,
  showUnpublishedFunds,
  showHasDataReviewFunds,
  queryOnCompanyName,
  queryOnName,
) => {
  let filteredFunds = [...funds];

  if (showHasDataReviewFunds) {
    if (showUnpublishedFunds) {
      filteredFunds = _.filter(funds, f => f.dataReviews.length > 0);
    } else {
      filteredFunds = _.filter(funds, f => f.dataReviews.length > 0 && f.published);
    }
  } else if (!showUnpublishedFunds) {
    filteredFunds = _.filter(funds, { published: true });
  }

  let query = queryOnCompanyName.toString().trim();
  if (query.length > 0) {
    const regex = new RegExp(query, 'i');
    filteredFunds = _.filter(
      filteredFunds, fund => (
        fund.company.name && fund.company.name.match(regex)
      ),
    );
  }

  query = queryOnName.toString().trim();
  if (query.length > 0) {
    const regex = new RegExp(query, 'i');
    filteredFunds = _.filter(
      filteredFunds, fund => (
        fund.nameAndStock.match(regex)
      ),
    );
  }

  return filteredFunds;
};

const publishOrUnpublishFund = (funds, fundId, published) => (funds.map(fund => {
  if (fund.id === fundId) {
    return { ...fund, published };
  }
  return { ...fund };
}));

const deactivate = (funds, fundId) => (funds.map(fund => {
  if (fund.id === fundId) {
    return { ...fund, active: false, published: false };
  }
  return { ...fund };
}));

const activate = (funds, fundId) => (funds.map(fund => {
  if (fund.id === fundId) {
    return { ...fund, active: true };
  }
  return { ...fund };
}));

const dataReviewApproved = (funds, { fundId, reviewId }) => (funds.map(fund => {
  if (fund.id === fundId) {
    return { ...fund, dataReviews: _.reject(fund.dataReviews, { id: reviewId }) };
  }
  return { ...fund };
}));

// eslint-disable-next-line complexity
const reducer = (state, { type, payload }) => {
  let newState;
  switch (type) {
    case 'setFunds':
      newState = {
        ...state,
        funds: payload,
      };
      break;
    case 'publishFund':
      newState = {
        ...state,
        funds: publishOrUnpublishFund(state.funds, payload, true),
      };
      break;
    case 'unpublishFund':
      newState = {
        ...state,
        funds: publishOrUnpublishFund(state.funds, payload, false),
      };
      break;
    case 'setShowUnpublishedFunds':
      newState = {
        ...state,
        showUnpublishedFunds: payload,
      };
      break;
    case 'setShowHasDataReviewFunds':
      newState = {
        ...state,
        showHasDataReviewFunds: payload,
      };
      break;
    case 'setFilterByCompanyName':
      newState = {
        ...state,
        queryOnCompanyName: payload,
      };
      break;
    case 'setFilterByName':
      newState = {
        ...state,
        queryOnName: payload,
      };
      break;
    case 'importFund':
      return {
        ...state,
        showImportModal: true,
      };
    case 'dismissImportModal':
      return {
        ...state,
        showImportModal: false,
      };
    case 'setViewFund':
      return {
        ...state,
        viewFund: payload,
        showViewModal: true,
        showImportModal: false,
      };
    case 'dismissViewModal':
      return {
        ...state,
        showViewModal: false,
      };
    case 'activateFund':
      newState = {
        ...state,
        funds: activate(state.funds, payload),
      };
      break;
    case 'deactivateFund':
      newState = {
        ...state,
        funds: deactivate(state.funds, payload),
      };
      break;
    case 'showDataReviewModal':
      return {
        ...state,
        ...payload,
        showDataReviewModal: true,
      };
    case 'dismissDataReviewModal':
      return {
        ...state,
        showDataReviewModal: false,
      };
    case 'dataReviewApproved':
      newState = {
        ...state,
        funds: dataReviewApproved(state.funds, payload),
        showDataReviewModal: false,
      };
      break;
    case 'setErrors':
      return { ...state, errors: payload };
    default:
      throw new Error();
  }

  return {
    ...newState,
    filteredFunds: filterFunds(
      newState.funds,
      newState.showUnpublishedFunds,
      newState.showHasDataReviewFunds,
      newState.queryOnCompanyName,
      newState.queryOnName,
    ),
  };
};

const defaultState = {
  funds: [],
  fund: {},
  filteredFunds: [],
  showUnpublishedFunds: true,
  showHasDataReviewFunds: false,
  queryOnCompanyName: '',
  queryOnName: '',
  showImportModal: false,
  showViewModal: false,
  viewFund: null,
  errors: {},
  showDataReviewModal: false,
  dataReview: {},
};

const FundsContext = React.createContext();

export default FundsContext;
export {
  defaultState,
  reducer,
};
